import React from "react";
import { TableRow, TableSortLabel } from "@mui/material";
import StyledTableCell  from "./tableStyles";

interface ColumnDef<T> {
  key: keyof T | string;
  id: keyof T | string;
  label: string;
  width?: number;
  align?: "left" | "right" | "center";
  sortable?: boolean;
  fontSize?: string;
  truncate?: number;
  wrap?: boolean;
}

interface TableHeaderProps<T> {
  columns: ColumnDef<T>[];
  sortConfig: { column: keyof T | string | null; direction: "asc" | "desc" };
  onSort: (columnId: keyof T | string) => void;
}

export default function TableHeader<T>({
  columns,
  sortConfig,
  onSort,
}: TableHeaderProps<T>) {
  return (
    <TableRow>
      {columns.map((column) => (
        <StyledTableCell
          key={column.id as string}
          align={column.align || "left"}
          style={{ width: column.width }}
          fontSize={column.fontSize}
        >
          {column.sortable ? (
            <TableSortLabel
              active={sortConfig.column === column.id}
              direction={
                sortConfig.column === column.id ? sortConfig.direction : "asc"
              }
              onClick={() => onSort(column.id)}
            >
              {column.label}
            </TableSortLabel>
          ) : (
            column.label
          )}
        </StyledTableCell>
      ))}
    </TableRow>
  );
}
